import { IElement, IPoint, TPlaceholderParam } from '../../grid.types'

const calcPlaceholderParamsForEl = (gridItem: IElement): TPlaceholderParam[] => {
  const numberPlaceholdersInGridItem = gridItem.height * gridItem.width
  if (numberPlaceholdersInGridItem === 0) return null
  const placeholderParams: TPlaceholderParam[] = []
  for (let i = 0; i < numberPlaceholdersInGridItem; i++) {
    placeholderParams.push({
      x: gridItem.x + (i % gridItem.width),
      y: gridItem.y + Math.floor(i / gridItem.width),
      active: true,
    })
  }
  return placeholderParams
}

const isElementContainPoint = (point: IPoint, element: IElement) => {
  if (!element || !point) return null

  return (
    element.x <= point.x &&
    element.width + element.x > point.x &&
    element.y <= point.y &&
    element.height + element.y > point.y
  )
}

const calcParamsForEachPlaceholderGridAtGrid = (
  cols: number,
  rows: number,
  element?: IElement
): TPlaceholderParam[] => {
  const points: TPlaceholderParam[] = []
  for (let y = 0; y < rows; y++) {
    for (let x = 0; x < cols; x++) {
      points.push({ x, y, active: element ? isElementContainPoint({ x, y }, element) : false })
    }
  }

  return points
}

const placeholderUtils = { calcPlaceholderParamsForEl, isElementContainPoint, calcParamsForEachPlaceholderGridAtGrid }

export default placeholderUtils
